module.exports = __webpack_public_path__ + "img/four-squares.9b83c89e.svg";